import { useNavigate } from 'react-router-dom';

/**
 * Shared page chrome for quotation sub-routes (back + title + actions).
 */
export function QuotationPageHeader({
  title,
  description,
  backTo = '/quotations',
  actions = null,
  showBorder = false,
  className = '',
}) {
  const navigate = useNavigate();

  return (
    <div
      className={`flex flex-col sm:flex-row sm:items-start justify-between gap-3 ${showBorder ? 'pb-3 mb-3 border-b border-border-default' : ''} ${className}`}
    >
      <div className="flex items-start gap-3 min-w-0">
        <button
          type="button"
          onClick={() => {
            if (window.history.length > 1) {
              navigate(-1);
            } else {
              navigate(backTo);
            }
          }}
          className="w-9 h-9 shrink-0 flex items-center justify-center rounded-lg border border-border-default bg-white text-text-secondary hover:text-text-primary hover:border-primary transition-colors"
          aria-label="Go back"
        >
          <svg
            className="w-5 h-5"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M15 18l-6-6 6-6" />
          </svg>
        </button>
        <div className="min-w-0">
          <h1 className="text-xl sm:text-h3 font-semibold text-text-primary tracking-wide truncate">
            {title}
          </h1>
          {description ? (
            <p className="text-sm text-text-secondary mt-1">{description}</p>
          ) : null}
        </div>
      </div>
      {actions ? (
        <div className="flex flex-wrap items-center gap-2 sm:justify-end">
          {actions}
        </div>
      ) : null}
    </div>
  );
}
